import {
  MatrixTypes,
} from '../../enums/GameEnums';
import { useEffect, useRef } from 'react';
import { observer } from 'mobx-react-lite';
import { Timer } from '../timer/timer';
import { gameStore } from '../../module/store/gameStore';
import {
  isMobile,
  useOutsideClick,
  useTranslation,
} from '@pascal/pascal-core';
import { useGamePad } from '../../module/hooks/useGamePad';
import { soundService } from '../../module/services/SoundService';
import { TKeys } from '../../core/constants/TKeys';
import { resultStore } from '../../module/store/resultStore';
import { betStatus } from '../../enums/BetStatus';

export const GamePad = observer((props) => {
  const {
    matrixType,
    resultReportState,
    doSpinState,
    quickBets,
    amount,
    isGamePadDisabled,
  } = gameStore;

  const { betResult } = resultStore

  const betsRef = useRef();
  const typeRef = useRef();
  const t = useTranslation();
  const [betsToggle, handleBetsToggle] = useOutsideClick(betsRef);
  const [typeToggle, handleTypeToggle] = useOutsideClick(typeRef);

  const {
    handleBetAmount,
    handleMatrixChange,
    handleStart,
    handleCashOutButton,
    handleSpaceSpin
    } = useGamePad()

  // useEffect(() => {
  //   document.addEventListener('keydown', handleSpaceSpin);
  //   return () => {
  //     document.removeEventListener('keydown', handleSpaceSpin);
  //   };
  // }, [handleSpaceSpin]);

  return (
    <div className={`${isMobile() ? 'mobile-' : ''}mines-game-bottom`}>
      <div className='mines-game-bottom-content'>
        <div className='m-g-b-area-inner'>
          <div className={`mines-g-b-btn-wrp dropdown ${doSpinState || resultReportState || isGamePadDisabled ? 'disabled' : ''}`}
               ref={typeRef}
               onClick={() => {
                 soundService.click()
                 handleTypeToggle()}
               }>
            <div className={`open-drop-holder ${typeToggle ? 'open' : ''}`}>
              <div className='open-drop-inner'>
                <div className='open-drop-inner-bg'>
                  <div className='open-drop-inside'>
                    {Object.values(MatrixTypes).map((matrix, index) =>
                      <div className={`open-drop-inside-g-number ${index === matrixType ? 'active' : ''}`}
                           onClick={() => handleMatrixChange(index)}
                           key={index}>
                        <span />
                        <p>{matrix.type}</p>
                      </div>,
                    )}
                  </div>
                </div>
              </div>
            </div>
            <div className='mines-g-b-btn-inner'>
              <div className='mines-block-btn-bg'>
                <div className='btn-square-block'><i className='icon-arrow-up' /></div>
              </div>
              <div className='mines-g-b-btn-holder'>
                <div className='mines-g-b-btn-count-wrp'>
                  <div className='mines-g-b-btn-count-icon' />
                  <p className='mines-g-b-btn-count-number'>{MatrixTypes[matrixType].type}</p>
                </div>
              </div>
            </div>
          </div>
          <div className={`mines-g-b-btn-wrp ${isGamePadDisabled ? 'disabled' : ''}`}>
            <div className={`mines-g-b-btn-inner ${!doSpinState && !resultReportState ? 'pulse-anim' : null}`}>
              <div className='mines-block-btn-bg type-1' />
              <div className='mines-g-b-btn-holder' onClick={handleStart}>
                {doSpinState || resultReportState ? <i className='icon-mix' /> : <p className='mines-g-b-btn-holder-text'>{t(TKeys.Start)}</p>}
              </div>
            </div>
          </div>
          {resultReportState && betResult?.status !== betStatus.lose ?
            <div className={`mines-g-b-btn-wrp cashout ${!resultReportState || isGamePadDisabled ? 'disabled' : ''}`}>
              <div className='mines-g-b-btn-inner'>
                <div className='mines-block-btn-bg type-2' />
                <div className={`mines-g-b-btn-holder ${resultReportState ? 'active' : ''}`}
                     onClick={handleCashOutButton}>
                  {/*<i className='icon-cash-out' />*/}
                  <p className='text-cash-out'>{t(TKeys.CashOut)}</p>
                </div>
              </div>
            </div>
            :
            <div
              className={`mines-g-b-btn-wrp ${doSpinState || resultReportState || isGamePadDisabled ? 'disabled' : ''}`}
              ref={betsRef}
              onClick={() => {
                soundService.click()
                handleBetsToggle()
                }
              }>
              <div className={`open-drop-holder ${betsToggle ? 'open' : ''}`}>
                <div className='open-drop-inner'>
                  <div className='open-drop-inner-bg'>
                    <div className='open-drop-inside'>
                      {quickBets.map((betAmount, index) =>
                        <div className={`open-drop-inside-g-number ${amount === quickBets[index] ? 'active' : ''}`}
                             onClick={() => handleBetAmount(index)}
                             key={index}>
                          <span />
                          <p>{betAmount}</p>
                        </div>,
                      )}
                    </div>
                  </div>
                </div>
              </div>
              <div className='mines-g-b-btn-inner'>
                <div className='mines-block-btn-bg' />
                <div className='btn-square-block'><i className='icon-arrow-up' /></div>
                <div className='mines-g-b-btn-holder'>
                  <i className='icon-coins ' />
                  <p className='text-money'>{amount}</p>
                </div>
              </div>
            </div>
          }
        </div>
      </div>
    </div>
  );
});
